import React, { Component } from "react";
import "./Concepts.css";
import Questions from "./Questions";
import XmlNodeStringFormat from "./XmlNodeStringFormat";

export default class Concepts extends Component {
  state = {
    answersNodes: {}
  };
  componentDidMount() {
    let ids = this.props.concepts
      .map((concept, index) => {
        return index === 0
          ? concept.attributes.id
          : ` ${concept.attributes.id}`;
      })
      .toString()
      .replace(",", "");
    this.props.onConceptRendered(XmlNodeStringFormat.ConceptNodeStart(ids));
  }

  onQuestionAnswered = async (id, nodes) => {
    const newAnswersNodes = {
      ...this.state.answersNodes,
      [id]: nodes
    };
    await this.setState({
      answersNodes: newAnswersNodes
    });
    let concatNodes = "";
    for (const [key,value] of Object.entries(newAnswersNodes)) {
      concatNodes += value + " ";
    }
    this.props.onQuestionAnswered(concatNodes);
  };

  render() {
    const { concepts } = this.props;
    return (
      <div className="concepts-container">
        {concepts.map(concept => (
          <>
            <div key={concept} className="c-title">{concept.attributes.description}</div>
            <Questions
              onQuestionAnswered={this.onQuestionAnswered}
              questions={concept.children}
              conceptId={concept.attributes.number}
            />
          </>
        ))}
      </div>
    );
  }
}
